module.exports = __webpack_public_path__ + "static/img/05-points-box.8a56cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-assignment-guide/05-points-box.png
// module id = X+th
// module chunks = 1